import { Routes, Route, useLocation } from 'react-router-dom'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { AiAssistant } from '@/components/AiAssistant'
import { Home } from '@/pages/Home'
import { Valuation } from '@/pages/Valuation'
import { Results } from '@/pages/Results'
import { Admin } from '@/pages/Admin'
import { AdminLogin } from '@/pages/AdminLogin'
import { ProtectedRoute } from '@/components/ProtectedRoute'

function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const isAdminRoute = location.pathname === '/admin' || location.pathname === '/admin/login'

  if (isAdminRoute) {
    return <>{children}</>
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex flex-col">{children}</main>
      <Footer />
      <AiAssistant />
    </div>
  )
}

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/valutazione" element={<Valuation />} />
        <Route path="/risultati" element={<Results />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Layout>
  )
}
